import * as htmlparser2 from 'htmlparser2';

export type Node = {
  type: string;
  name?: string;
  attribs?: Record<string, string>;
  children?: Node[];
  data?: string;
};

export const NODE_TYPES = {
  ROOT: 'root',
  TAG: 'tag',
  TEXT: 'text',
};

export const TAGS = {
  LINK: 'a',
  PARAGRAPH: 'p',
  UNORDERED_LIST: 'ul',
  LIST_ITEM: 'li',
  SUP: 'sup',
};

export const parseHtmlToJson = (html: string): Node[] => {
  const stack: Node[] = [{ type: NODE_TYPES.ROOT, children: [] }];

  const parser = new htmlparser2.Parser(
    {
      onopentag(name, attribs): void {
        const node = { type: NODE_TYPES.TAG, name, attribs: attribs || {}, children: [] };
        const parent = stack[stack.length - 1];
        if (parent?.children) {
          parent.children.push(node);
        }
        stack.push(node);
      },
      ontext(text): void {
        if (text.trim().length > 0) {
          stack[stack.length - 1]?.children?.push({ type: NODE_TYPES.TEXT, data: text });
        }
      },
      onclosetag(): void {
        stack.pop();
      },
    },
    { decodeEntities: false },
  );

  parser.write(html);
  parser.end();

  return stack[0].children ?? [];
};
